<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
    components: {},
    props: {
        length: {
            type: Number,
            required: true,
        },
        active: {
            type: Number,
            default: 0,
        },
    },
    emits: ["click"],
    data: () => ({}),
    computed: {},
    methods: {},
});
</script>

<template>
    <div class="flex flex--valign-c flex--gap-5">
        <div v-for="(number, idx) in length" :key="number" class="carousel-dot" :class="{ active: idx === active }" @click.stop="$emit('click', idx)"></div>
    </div>
</template>

<style lang="scss" scoped>
.carousel-dot {
    border-radius: 50%;
    background: #fff;
    box-shadow: 1px 2px 2px rgb(0 0 0 / 35%);
    height: 18px;
    width: 18px;
    transition:
        transform 0.3s ease-in-out,
        opacity 0.2s ease-in-out;
    pointer-events: all;
    cursor: pointer;

    &:not(.active) {
        transform: scale(0.6);
        opacity: 0.6;

        &:hover {
            transform: scale(0.8);
            opacity: 1;
        }
    }
}
</style>
